import { FC } from 'react';
import { IdentityVerificationState } from '../useIdentityVerification';

interface DocumentPreviewProps {
  state: IdentityVerificationState;
  compact?: boolean;
}

export const DocumentPreview: FC<DocumentPreviewProps> = ({ state, compact = true }) => {
  if (!state.previewUrl) return null;

  const isPdf =
    !state.previewMimeType || state.previewMimeType.toLowerCase().includes('pdf');
  const heightClass = compact ? 'h-40' : 'h-56';
  const title = state.fileName || '';

  return (
    <div
      className={`bg-gray-100 rounded-lg overflow-hidden border border-gray-200 ${heightClass}`}
    >
      {isPdf ? (
        <iframe
          src={`${state.previewUrl}#toolbar=0&navpanes=0`}
          title={title}
          className="w-full h-full border-0"
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center">
          <img
            src={state.previewUrl}
            alt={title}
            className="max-w-full max-h-full object-contain"
          />
        </div>
      )}
    </div>
  );
};
